// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".off-1 {\n    fill: #e6e6e6;\n  }\n\n.off-2 {\n    fill: #fff;\n  }", ""]);
// Exports
module.exports = exports;
